export const PRIVACY_PDF_URL =
  'https://docs.google.com/viewerng/viewer?url=https://assets.khatabook.com/khatabook-website/kb-privacy-policy.pdf&embedded=true';
